// mw js

$( document ).ready(function() {
    // trigger quick view button  
    const quickViewEl = document.querySelectorAll(".quick__view");
    for(let i = 0; i < quickViewEl.length; i++){
        quickViewEl[i].addEventListener("click",function(e){
            let pageYpos = window.pageYOffset;
            e.target.closest(".cart_btn_quick_review").previousElementSibling.previousElementSibling.querySelector(".thumbnail-overlay .info span.quick_shop").click();
            window.scroll(0, pageYpos);
        });
    }

    // hide announce bar
    $('.header .promo_banner-close').click(function(){
        $(this).parents('.promo_banner').hide();
    })

    //product page accordion
    $('.product_metafield_accordian_inner').click(function(){
        $('.product_metafield_accordian_main').find('.active_product_metafield_accordian');
        $(this).toggleClass('active_product_metafield_accordian');
    });

    // cart background color red when cart count grater then 0
    if($('header .header .cart_count').html() > 0){
        $('header .header .logo_cart_bar ').addClass('logo_cart_bar_js');
    }

    let cartEl = document.querySelector(".cart_search_bar .cart_container");
    jQuery("header .header .cart_count").bind("DOMSubtreeModified", function(e, i) {
        cartEl.classList.add("active_link");
        if($('header .header .cart_count').html() > 0){
            $('header .header .logo_cart_bar ').addClass('logo_cart_bar_js');
        }
        else{
            $('header .header .logo_cart_bar ').removeClass('logo_cart_bar_js');
        }
    });

});

jQuery(window).on("load", function(){
        // change add to cart button text
        $(".ajax-submit span").html("Add to Cart");
});

